// Core
import { Component } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = ({ router }) => ({
    ...router,
});

@connect(mapStateToProps)
export class ScrollToTop extends Component {
    componentDidUpdate (prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render () {
        return null;
    }
}
